export const SMSCourseConstants = {
    GETALL_REQUEST: 'COURSE_GETALL_REQUEST',
    GETALL_SUCCESS: 'COURSE_GETALL_SUCCESS',
    GETALL_FAILURE: 'COURSE_GETALL_FAILURE',

};



// WEBPACK FOOTER //
// ./src/_constants/sms-course.constants.js